<div class="relative">
	<div class="flex grid-rows-1 flex-row gap-4">
		<button
			class="button-nav h-[24px] !min-w-6 border bg-teal !p-0"
			(click)="onPrev()"
			mat-stroked-button
			[disabled]="current == 0"
		>
			<mat-icon class="pl-1 !align-baseline">chevron_left</mat-icon>
		</button>
		<div class="text-lg font-bold leading-6 text-violet">
			{{ candidateList[current].candidateDetails.name }}
		</div>
		<button
			(click)="onNext()"
			class="button-nav h-[24px] !min-w-6 border bg-teal !p-0"
			mat-stroked-button
			[disabled]="current === candidateList.length - 1"
		>
			<mat-icon class="pl-1 !align-baseline">chevron_right</mat-icon>
		</button>
	</div>
	<div class="slide-wrapper">
		@for (candidate of candidateList; track candidate; let i = $index) {
			<app-cbta-form-navigator [isIn]="current === i" [left]="isLeftTransition(i)">
				<div class="mt-8 px-0 lg:px-6">
					<h2 class="text-center !text-[16px] !font-bold !leading-6">{{ summaryReportTitle }}</h2>
					<div class="mb-8 mt-4 flex justify-end">
						@if (stepper.selectedIndex === 0) {
							<img src="{{ candidate?.logo }}" alt="AOC" class="w-[150px]" />
						}
					</div>
				</div>
				<mat-stepper id="report-summary-stepper" #stepper>
					<mat-step>
						<div id="summary-report" #summaryReport class="avoid-break break-after w-full px-0 lg:px-6">
							<div class="grid grid-cols-2 gap-8 p-8 pt-4">
								<div class="form-display flex flex-col gap-2">
									<label class="form-label">Training Date</label>
									<div class="form-value">
										{{ formatSummaryDate($safeNavigationMigration(candidate?.trainingDate)) }}
									</div>
								</div>
								<div class="form-display flex flex-col gap-2">
									<label class="form-label">Session</label>
									<div class="form-value">
										{{ join($safeNavigationMigration(candidate?.candidateDetails?.candidateSessionConfigurations)) }}
									</div>
								</div>
							</div>
							<!-- Candidate Details -->
							<div
								class="flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
							>
								Candidate Details
							</div>
							<div class="grid grid-cols-2 gap-8 p-8 pt-4">
								<div class="form-display flex flex-col gap-2">
									<label class="form-label">Name</label>
									<div class="form-value">
										{{ candidate?.candidateDetails?.name }}
									</div>
								</div>
								<div class="form-display flex flex-col gap-2">
									<label class="form-label">Rank</label>
									<div class="form-value">
										{{ candidate?.candidateDetails?.rank }}
									</div>
								</div>
								<div class="form-display flex flex-col gap-2">
									<label class="form-label">Staff Number</label>
									<div class="form-value">
										{{ candidate?.candidateDetails?.staffNumber }}
									</div>
								</div>
								<div class="form-display flex flex-col gap-2">
									<label class="form-label">Trainee Profile</label>
									<div class="form-value">
										{{ candidate?.candidateDetails?.trainingProfile }}
									</div>
								</div>
								<div class="form-display flex flex-col gap-2">
									<label class="form-label">License Number</label>
									<div class="form-value">
										{{ candidate?.candidateDetails?.licenseNumber }}
									</div>
								</div>
								<div class="form-display flex flex-col gap-2">
									<label class="form-label">License Expiry Date</label>
									<div class="form-value">
										{{ formatSummaryDate($safeNavigationMigration(candidate?.candidateDetails?.licenseExpiryDate)) }}
									</div>
								</div>
							</div>
							<app-flight-simulator-summary-fields-v2
								[details]="$safeNavigationMigration(candidate?.flightSimulatorDetails)"
							/>
							<div class="grid grid-rows-1 gap-4">
								<div
									class="flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
								>
									Session Details
								</div>
							</div>
							<div
								class="mt-4 grid grid-cols-2 gap-x-10 gap-y-6 bg-[#F6FAFF] p-8 lg:gap-x-16 lg:gap-y-16 lg:bg-[#FBFCFE]"
							>
								<div>
									<div class="rating-label">Grading A : How Many</div>
									<div class="rating-box">
										<div
											[class.active]="
												$safeNavigationMigration(candidate?.sessionDetails?.ratingA) === null ||
												candidate?.sessionDetails?.ratingA === 1
											"
											class="rating-box-item"
										>
											1
										</div>
										<div [class.active]="candidate?.sessionDetails?.ratingA === 2" class="rating-box-item">2</div>
										<div [class.active]="candidate?.sessionDetails?.ratingA === 3" class="rating-box-item">3</div>
										<div [class.active]="candidate?.sessionDetails?.ratingA === 4" class="rating-box-item">4</div>
										<div [class.active]="candidate?.sessionDetails?.ratingA === 5" class="rating-box-item">5</div>
									</div>
								</div>
								<div>
									<div class="rating-label">Grading B : How Often</div>
									<div class="rating-box">
										<div
											[class.active]="
												$safeNavigationMigration(candidate?.sessionDetails?.ratingB) === null ||
												candidate?.sessionDetails?.ratingB === 1
											"
											class="rating-box-item"
										>
											1
										</div>
										<div [class.active]="candidate?.sessionDetails?.ratingB === 2" class="rating-box-item">2</div>
										<div [class.active]="candidate?.sessionDetails?.ratingB === 3" class="rating-box-item">3</div>
										<div [class.active]="candidate?.sessionDetails?.ratingB === 4" class="rating-box-item">4</div>
										<div [class.active]="candidate?.sessionDetails?.ratingB === 5" class="rating-box-item">5</div>
									</div>
								</div>
								<div>
									<div class="rating-label">Grading C : TEM Safety Outcome</div>
									<div class="rating-box">
										<div
											[class.active]="
												$safeNavigationMigration(candidate?.sessionDetails?.ratingC) === null ||
												candidate?.sessionDetails?.ratingC === 1
											"
											class="rating-box-item"
										>
											1
										</div>
										<div [class.active]="candidate?.sessionDetails?.ratingC === 2" class="rating-box-item">2</div>
										<div [class.active]="candidate?.sessionDetails?.ratingC === 3" class="rating-box-item">3</div>
										<div [class.active]="candidate?.sessionDetails?.ratingC === 4" class="rating-box-item">4</div>
										<div [class.active]="candidate?.sessionDetails?.ratingC === 5" class="rating-box-item">5</div>
									</div>
								</div>
								<div class="final-rating">
									<div class="rating-label">Grading D : Final Grading</div>
									<div class="rating-box">
										<div
											[class.active]="
												$safeNavigationMigration(candidate?.sessionDetails?.finalRating) === null ||
												candidate?.sessionDetails?.finalRating === 1
											"
											class="rating-box-item"
										>
											1
										</div>
										<div [class.active]="candidate?.sessionDetails?.finalRating === 2" class="rating-box-item">2</div>
										<div [class.active]="candidate?.sessionDetails?.finalRating === 3" class="rating-box-item">3</div>
										<div [class.active]="candidate?.sessionDetails?.finalRating === 4" class="rating-box-item">4</div>
										<div [class.active]="candidate?.sessionDetails?.finalRating === 5" class="rating-box-item">5</div>
										<div class="rating-border"></div>
									</div>
								</div>
							</div>
							<div class="mt-6 grid grid-cols-2 gap-8 p-8">
								<div class="space-y-8">
									<div class="form-display flex flex-col gap-2">
										<label class="form-label">Instructor Name</label>
										<div class="form-value">
											{{ candidate?.sessionDetails?.instructorName }}
										</div>
									</div>
									<div class="form-display flex flex-col gap-2">
										<label class="form-label">License Number</label>
										<div class="form-value">
											{{ candidate?.examinerNumber ?? "-" }}
										</div>
									</div>
								</div>
								<div class="form-display flex flex-col gap-2">
									<label class="form-label">Instructor Signature</label>
									<div class="flex h-24 w-72 flex-col items-center gap-4 bg-[#F6FAFF]">
										@if (
											helperService.bufferDataToImageUrl(
												$safeNavigationMigration(candidate?.sessionDetails?.instructorSignature?.data)
											)
										) {
											<img
												[src]="
													helperService.bufferDataToImageUrl(
														$safeNavigationMigration(candidate?.sessionDetails?.instructorSignature?.data)
													)
												"
												alt="Signature"
												class="h-full"
											/>
										}
										<span class="text-sm font-medium">{{ candidate?.signOffDate }}</span>
									</div>
								</div>
							</div>
							<div class="my-4 h-0.5 w-full bg-[#CFE3FF]"></div>
							<div class="grid grid-cols-2 gap-8 p-8">
								<div>
									<div class="form-display flex flex-col gap-2">
										<label class="form-label">Candidate name</label>
										<div class="form-value">
											{{ candidate?.candidateDetails?.name }}
										</div>
									</div>
								</div>
								<div class="form-display flex flex-col gap-2">
									<label class="form-label">Candidate Signature</label>
									<div class="flex h-24 w-72 flex-col items-center gap-4 bg-[#F6FAFF]">
										@if (
											helperService.bufferDataToImageUrl(
												$safeNavigationMigration(candidate?.sessionDetails?.traineeSignature?.data)
											)
										) {
											<img
												[src]="
													helperService.bufferDataToImageUrl(
														$safeNavigationMigration(candidate?.sessionDetails?.traineeSignature?.data)
													)
												"
												alt="Signature"
												class="h-full"
											/>
										}
										<span class="text-sm font-medium">{{ candidate?.signOffDate }}</span>
									</div>
								</div>
							</div>
							<div id="instructor-notes" #instructorNotes class="avoid-break break-after mt-5">
								<!-- Instructor Notes/Comments -->
								<div
									class="mb-6 flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
								>
									Instructor Notes/Comments
								</div>
								<div class="mt-8">
									<div class="text-sm font-medium text-grey-60">Summary</div>
									<div class="mt-4 min-h-40 rounded-md border border-blue-20 px-8 py-6 text-[85%] uppercase">
										<app-cbta-rating-summary-comments
											[comments]="candidate?.trainerExaminerNotes?.summary ?? []"
										></app-cbta-rating-summary-comments>
									</div>
								</div>
								<div class="mt-8">
									<div class="text-sm font-medium text-grey-60">Other Training & Observations</div>
									<div class="mt-4 min-h-40 rounded-md border border-blue-20 px-8 py-6">
										@for (comment of candidate?.trainerExaminerNotes?.otherTrainingAndObservations; track comment) {
											@if (!helperService.isEmptyComment(comment)) {
												<p class="mb-1 whitespace-pre-wrap break-words text-left font-medium uppercase">
													{{ comment + `\n` }}
												</p>
											}
										}
									</div>
								</div>
							</div>
						</div>
					</mat-step>
					<mat-step>
						<div id="report-maneuver-breakdown" #maneuverBreakdownRef class="avoid-break">
							<div
								class="mb-header flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
							>
								Maneuver Breakdown
							</div>
							@if (candidateList[current] && candidateList[current].maneuverBreakdown) {
								@if (observationForm) {
									<div [formGroup]="observationForm" class="avoid-break">
										<ng-container formArrayName="observations">
											<div class="mt-4">
												@for (ob of observations.controls; track ob; let i = $index) {
													<div class="mb-item">
														<div
															class="mb-label flex h-[76px] items-center justify-start bg-blue-20 px-8 text-2xl font-medium italic text-black lg:bg-violet-light lg:text-violet"
														>
															Maneuver {{ i + 1 }}: {{ meneuverNameList[i] }}
														</div>
														<div class="py-4">
															<div>
																<app-view-maneuver
																	[maneuverForm]="observations.at(i)"
																	[addRemoveList]="obAddRemoveList[i]"
																>
																</app-view-maneuver>
															</div>
														</div>
													</div>
												}
											</div>
										</ng-container>
									</div>
								}
							}
						</div>
					</mat-step>
				</mat-stepper>
				<div class="mt-[40px] flex items-center gap-4 px-6">
					<button
						[disabled]="stepper.selectedIndex === 0"
						(click)="goBack(stepper)"
						mat-stroked-button
						class="min-w-[63px] border !border-b-2 !border-[#D9DBE0] !text-black disabled:opacity-50"
					>
						Back
					</button>
					<button
						(click)="goNext(stepper)"
						mat-stroked-button
						class="min-w-[63px] border !border-b-2 !border-[#D9DBE0] !text-black"
					>
						Next
					</button>
					<div class="flex-1"></div>
				</div>
			</app-cbta-form-navigator>
		}
	</div>
</div>
